import { http, HttpResponse } from "msw";
import { getMockProducts } from "../data/products";

export const productHandlers = [
  http.get("/api/v2/descriptions/:language", async ({ params }) => {
    const lang = (params.language as string) || "en";
    const products = await getMockProducts(lang);
    return HttpResponse.json(products);
  }),

  http.get("/api/v2/admin/descriptions/:language", async ({ params }) => {
    const lang = (params.language as string) || "en";
    const products = await getMockProducts(lang);
    return HttpResponse.json(products);
  }),

  // Per-product instruction payloads. Real backend returns wildly varying
  // shapes per product — this map mirrors the shapes uiv2 actually consumes.
  http.get("/api/v2/instructions/data/:product", ({ params }) => {
    const product = params.product as string;
    const instructionsMap: Record<string, Record<string, unknown>> = {
      tak: {
        server_url: "tak.demo.dev.pvarki.fi",
        server_port: 8089,
        protocol: "ssl",
        status: "online",
        connected_clients: 12,
        tak_zips: [
          {
            title: "ATAK (Android / Windows)",
            filename: "atak-demo.zip",
            data: "data:application/zip;base64,UEsFBgAAAAAAAAAAAAAAAAAAAAAAAA==",
          },
          {
            title: "iTAK (iOS)",
            filename: "itak-demo.zip",
            data: "data:application/zip;base64,UEsFBgAAAAAAAAAAAAAAAAAAAAAAAA==",
          },
          {
            title: "Tracker",
            filename: "tracker-demo.zip",
            data: "data:application/zip;base64,UEsFBgAAAAAAAAAAAAAAAAAAAAAAAA==",
          },
        ],
      },
      mtx: {
        streams: [
          {
            name: "fighter420",
            url: "rtsp://mtx.demo.dev.pvarki.fi/fighter420",
            viewers: 42,
            status: "live",
          },
        ],
      },
      bl: {
        recent_events: [
          {
            id: 1,
            timestamp: new Date(Date.now() - 3600000).toISOString(),
            callsign: "TacticalTina",
            event: "Patrol started at Grid 12345678",
            type: "movement",
          },
          {
            id: 2,
            timestamp: new Date(Date.now() - 1800000).toISOString(),
            callsign: "fighter420",
            event: "Contact report: 3 vehicles spotted NE",
            type: "observation",
          },
          {
            id: 3,
            timestamp: new Date(Date.now() - 900000).toISOString(),
            callsign: "JanneJaeger",
            event: "Checkpoint ALPHA secured",
            type: "status",
          },
        ],
      },
      matrix: {
        rooms: [
          { id: "!demo-ops:demo.dev.pvarki.fi", name: "Ops", members: 8 },
          { id: "!demo-int:demo.dev.pvarki.fi", name: "Intel", members: 5 },
        ],
      },
    };
    return HttpResponse.json({
      data: instructionsMap[product] || {},
    });
  }),
];
